import Button from '@klv/atoms/button';
import { generateClassName } from '@klv/shared/utils/functions';

import { hasSideDownloadCtaData } from './utils';
import * as styles from './styles/sideDownloadCta.module.scss';

import type { ISideDownloadCta } from './types';


const SideDownloadCta = ({
  backgroundColor = 'sand',
  bodyCopy = '',
  buttons = [],
  className,
  headline = '',
  thumbnail,
  ...props
}: ISideDownloadCta) => {
  if (!(hasSideDownloadCtaData({ backgroundColor, bodyCopy, buttons, headline, thumbnail }))) return null;

  const hasImage = Object.keys(thumbnail || {}).length > 0 && thumbnail?.sourceUrl !== undefined;
  const darkColors = ['cedar', 'charcoal', 'ocean', 'storm'];

  return (
    <div
      className={generateClassName([className, styles.sideDownloadCta, hasImage ? styles.hasImage : ''])}
      style={{
        '--background-color': `var(--color-${backgroundColor})`,
        '--text-color': `var(--color-${darkColors.includes(backgroundColor) ? 'white' : 'charcoal'})`,
      } as React.CSSProperties}
      {...props}
    >
      {hasImage && (
        <img
          alt={thumbnail?.altText || ''}
          className={styles.thumbnail}
          sizes={thumbnail?.sizes}
          src={thumbnail?.sourceUrl}
          srcSet={thumbnail?.srcSet}
        />
      )}
      <div>
        {(headline !== '') && (
          <div className={generateClassName([styles.headline, 'h6 semibold'])}>{headline}</div>
        )}
        {(bodyCopy !== '') && (
          <div className={generateClassName(['p2', styles.bodyCopy])}>{bodyCopy}</div>
        )}
        {(buttons?.length > 0) && buttons.map((button) => (
          <Button {...button} buttonColor={darkColors.includes(backgroundColor) ? 'light' : 'dark'}/>
        ))}
      </div>
    </div>
  );
};

export default SideDownloadCta;
